export enum PlaybookTemplateKey {
    powerplatformInsecureCommunication = "powerplatformInsecureCommunication",
    powerplatformPersonalDataAccess = "powerplatformPersonalDataAccess",
    powerplatformImplicitSharing = "powerplatformImplicitSharing",
    powerplatformSuspiciousDataFlow = "powerplatformSuspiciousDataFlow",
    powerplatformExternalUsersAccess = "powerplatformExternalUsersAccess",
    powerplatformCustomConnectorMissingAuthentication = "powerplatformCustomConnectorMissingAuthentication",
    powerplatformAnonymousAgentTriggerAccess = "powerplatformAnonymousAgentTriggerAccess",
    workatoPersonalDataAccess = "workatoPersonalDataAccess",
    workatoInsecureCommunication = "workatoInsecureCommunication",
    workatoSuspiciousDataFlow = "workatoSuspiciousDataFlow",
}
